import React from 'react';
import { useHistory } from 'react-router-dom';
import { BackButtonStyled, BackTextStyled } from './styles';
import BackArrow from '../../../../../../assets/icons/back-arrow.svg';

const BackButton = (props) => {
  const history = useHistory();
  return (
    <BackButtonStyled type={'button'} {...props} onClick={() => history.goBack()}>
      <img src={ BackArrow } loading='lazy' alt='back arrow icon' />
      <BackTextStyled>Atrás</BackTextStyled>
    </BackButtonStyled>
  )
};

export default BackButton;